<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong> Leave Approval </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="no-display" dense justify="center">
                <v-col cols="12" sm="3" md="3">
                    <p><v-icon color="error">*</v-icon><b>Organization</b></p>
                    <v-autocomplete
                        rounded
                        dense
                        required
                        color="#0F2027"
                        v-model="org"
                        :items="org_list"
                        item-text="name"
                        return-object
                        label="Organization"
                        outlined
                        @click="clear()"
                        @change="getLeaveApprovalData()"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" v-if="org">
                    <p><v-icon color="error">*</v-icon><b>Leave Academic Year</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="ay"
                        :items="ay_list"
                        item-text="ay"
                        return-object
                        label="Leave Academic Year"
                        outlined
                        persistent-hint
                        hint="Please Select Leave Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="3" v-if="org">
                    <p><v-icon color="error">*</v-icon><b>Leave Type</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="leave_type"
                        :items="leave_type_list"
                        item-text="type"
                        item-value="id"
                        label="Leave Type"
                        outlined
                        persistent-hint
                        hint="Please Select Leave Type"
                    />
                </v-col>
                <v-col cols="12" sm="3" v-if="org">
                    <p><v-icon color="error">*</v-icon><b>Leave Approval Status</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="leave_approval_status"
                        :items="leave_approval_status_list"
                        item-text="displayName"
                        item-value="id"
                        label="Leave Approval Status"
                        outlined
                        persistent-hint
                        hint="Please Select Leave Approval Status"
                    />
                </v-col>
                <v-col cols="12" sm="3">
                    <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                    <v-menu
                        v-model="menu11"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                persistent-hint
                                hint="YYYY/MM/DD FORMAT INCLUSIVE"
                                placeholder="Inclusive"
                                color="#0F2027"
                                v-model="date_1"
                                outlined
                                rounded
                                dense
                                label="From Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="date_1" @input="menu11 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3">
                    <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                color="#0F2027"
                                persistent-hint
                                hint="YYYY/MM/DD FORMAT EXCLUSIVE"
                                placeholder="Exclusive"
                                v-model="date_2"
                                outlined
                                rounded
                                dense
                                label="To Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker :min="date_1" v-model="date_2" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3">
                    <p><v-icon color="error">*</v-icon><b>Instructor</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="instructor"
                        :items="instructor_list"
                        item-text="name"
                        item-value="id"
                        label="Instructor"
                        outlined
                        persistent-hint
                        hint="Please Select Instructor"
                    />
                </v-col>
            </v-row>
            <v-row
                justify="center"
                dense
                v-if="
            ay != '' &&
            leave_type != '' &&
            leave_approval_status != '' &&
            date_1 != '' &&
            date_2 != '' &&
            instructor != ''
          "
            >
                <v-btn class="button" @click="fetch()" :loading="loader">Fetch</v-btn>
            </v-row>
        </v-card>
        <v-card class="box" v-if="emp_leave_approval_transaction_list != ''">
            <v-toolbar dense flat class="toolbar">
                <v-toolbar-title>Employee Leave Approval</v-toolbar-title>
            </v-toolbar>
            <br />
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details> </v-text-field
            ><br /><br />
            <span style="width: 20px"></span>
            <v-data-table
                :headers="headers"
                :items="emp_leave_approval_transaction_list"
                class="mytable elevation-1"
                :search="search"
                dense
                show-select
                v-model="selected"
                item-key="id"
            >
                <template v-slot:[`item.remark`]="{ item }">
                    <!-- <input placeholder="Enter Remark." type="text" class="input text-center" v-model="item.remark" :name="item.remark" :rules="[v => !!v || 'Required' || v >= 0]" /> -->
                    <v-text-field
                        v-if="item.update_flag == true"
                        outlined
                        dense
                        flat
                        color="#0F2027"
                        class="pt-1 shrink mx-4"
                        full-width
                        v-model="item.remark"
                        label="Enter Remark."
                        placeholder="Enter Remark."
                    ></v-text-field>
                    <v-text-field
                        filled
                        v-if="item.update_flag == false"
                        readonly
                        outlined
                        dense
                        flat
                        color="#0F2027"
                        full-width
                        class="pt-1 shrink mx-4"
                        v-model="item.remark"
                        label="Enter Remark."
                        placeholder="Enter Remark."
                    ></v-text-field>
                </template>
                <template v-slot:[`item.file`]="{ item }">
                    <span v-if="item.file == 'YES'">
                        <a class="p-2" :href="aws_path + item.filepath" target="blank">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-if="item.filepath !== null" v-bind="attrs" v-on="on">
                                        <v-icon color="black">mdi-eye</v-icon></v-btn
                                    >
                                </template>
                                <span> View File!!! </span>
                            </v-tooltip>
                        </a>
                    </span>
                    <span v-if="item.file == 'NO'"> -- </span>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <v-autocomplete
                        v-if="item.update_flag == true"
                        class="pt-2"
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="item.status"
                        :items="leave_approval_status_details_list"
                        item-text="status"
                        return-object
                        label="Selcet Approving Status"
                        outlined
                    />
                    <v-autocomplete
                        filled
                        v-if="item.update_flag == false"
                        readonly
                        class="pt-2"
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="item.status"
                        :items="leave_approval_status_details_list"
                        item-text="status"
                        return-object
                        label="Selcet Approving Status"
                        outlined
                    />
                </template>
                <template v-slot:[`item.details`]="{ item }">
                    <v-btn
                        class="ma-2"
                        tile
                        outlined
                        color="success"
                        @click="showdetails(item.emp_leave_transaction_id)"
                    >
                        <v-icon left>mdi-arrow-right-bold-circle-outline</v-icon>
                        Details</v-btn
                    >
                </template>
                <template v-slot:[`item.update`]="{ item }">
                    <v-btn
                        v-if="item.update_flag == true"
                        class="mt-1 mb-1 button"
                        outlined
                        rounded
                        small
                        :loading="update_loader"
                        @click="update(item)"
                        >Update</v-btn
                    >
                    <v-btn v-if="item.update_flag == false" text color="error" small
                        >Already Updated / {{ item.update_remark }}</v-btn
                    >
                </template>
            </v-data-table>
            <br />
            <v-row dense justify="center" v-if="this.selected.length > 0">
                <v-col cols="12" sm="6" md="6">
                    <p><b>Remark</b></p>
                    <v-textarea outlined name="input-7-4" v-model="addRemark" label="Enter Remark"> </v-textarea>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="this.selected.length > 0">
                <v-col cols="12" sm="2">
                    <v-btn
                        color="warning"
                        @click="approveBulkLeaves()"
                        :disabled="selected.length > 0 ? false : true"
                        :loading="update_loader"
                        >Approve Leaves</v-btn
                    >
                </v-col>
                <v-col cols="12" sm="2">
                    <v-btn
                        color="error"
                        @click="RejectBulkLeaves()"
                        :loading="update_loader"
                        :disabled="selected.length > 0 ? false : true"
                        >Reject Leaves</v-btn
                    >
                </v-col>
                <v-col cols="12" sm="2">
                    <v-btn
                        color="primary"
                        @click="cancelBulkLeaves()"
                        :loading="update_loader"
                        :disabled="selected.length > 0 ? false : true"
                        >Cancel Leaves</v-btn
                    >
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="this.selected.length > 0">
                <strong>Total Selected - {{ selected.length }}</strong>
            </v-row>
        </v-card>
        <v-row justify="center" dense v-if="emp_approval_details != ''">
            <v-dialog v-model="dialog" persistent max-width="1500" v-if="emp_approval_details!=''">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Leave Details</v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense class="elevation-1" v-if="emp_approval_details!=''">
                                    <thead>
                                        <tr>
                                            <td>From Date</td>
                                            <td>To Date</td>
                                            <td>Application Date</td>
                                            <td>Number Of Days</td>
                                            <td>Number Of Hours</td>
                                            <td>Reason</td>
                                            <td>Is Load Adjustment Done</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ emp_approval_details[0].fromdate }}</td>
                                            <td>{{ emp_approval_details[0].todate }}</td>
                                            <td>{{ emp_approval_details[0].application_date }}</td>
                                            <td>{{ emp_approval_details[0].numberofdays }}</td>
                                            <td>{{ emp_approval_details[0].number_of_hours }}</td>
                                            <td>{{ emp_approval_details[0].reason }}</td>
                                            <td>
                                                <span
                                                    v-if="
                            emp_approval_details[0].is_load_adjustment_done
                        "
                                                    >YES</span
                                                >
                                                <span v-else>NO</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense class="elevation-1" v-if="emp_approval_details!=''">
                                    <thead>
                                        <tr>
                                            <td>Alternate Arrangement Person Name</td>
                                            <td>Alternate Arrangement Person Contact Number</td>
                                            <td>Nature Of Work</td>
                                            <td>Place Of Work</td>
                                            <td>Email</td>
                                            <td>Mobile</td>
                                            <td>Medical Certificate / Other Document</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ emp_approval_details[0] .alternate_arragement_person_name }}</td>
                                            <td>{{ emp_approval_details[0] .alternate_arragement_person_no }}</td>
                                            <td>{{ emp_approval_details[0].nature_of_work }}</td>
                                            <td>{{ emp_approval_details[0].place_of_work }}</td>
                                            <td>{{ emp_approval_details[0].email }}</td>
                                            <td>{{ emp_approval_details[0].contact_phone_number }}</td>
                                            <td>
                                                <span
                                                    v-if="
                            emp_approval_details[0].certificate_file_name !=
                            'NA'
                        "
                                                >
                                                    <a
                                                        class="p-2"
                                                        :href="
                            aws_path +
                            emp_approval_details[0].certificate_file_name                              
                            "
                                                        target="blank"
                                                    >
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="black">mdi-eye</v-icon></v-btn
                                                                >
                                                            </template>
                                                            <span> View Certificate / Other Document File!!! </span>
                                                        </v-tooltip>
                                                    </a>
                                                </span>
                                                <span v-else>
                                                    {{ emp_approval_details[0].certificate_file_name }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-data-table
                                    :headers="headers1"
                                    :items="emp_approval_details[0].emp_approval"
                                    class="mytable elevation-1"
                                    dense
                                >
                                </v-data-table>
                            </v-col>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="employee_leave_approved_details_list.length > 0">
                        <v-card class="box">
                            <v-toolbar dense class="toolbar">
                                <v-toolbar-title
                                    >Approved Leaves For This Month - {{ month_transaction_count }}</v-toolbar-title
                                > </v-toolbar
                            ><br />
                            <v-data-table
                                :headers="headers2"
                                :items="employee_leave_approved_details_list"
                                class="mytable elevation-1"
                                dense
                            >
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-row justify="center" dense>
                        <v-btn class="button" @click="dialog = false">Close</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard

    export default {
        data() {
            return {
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                breadcrumbClass: "breadcrumb-style1",
                search: null,
                snackbar_msg: null,
                org_list: null,
                display_data: false,
                org_data_list: [],
                division_list: [],
                dialog: false,
                org_data: [],
                fetch_loader: false,
                header_list: [],
                org: null,
                leaves_list: null,
                leave_type_list: null,
                leave_type: null,
                ay_list: [],
                ay: "",
                leave_approval_status_list: null,
                leave_approval_status: null,
                instructor_list: null,
                instructor: null,
                date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
                modal_1: false,
                date_2: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
                modal_2: false,
                menu: false,
                menu2: false,
                menu1: false,
                dialog: false,
                menu11: false,
                leave_approval_status_details_list: [],
                emp_leave_approval_transaction_list: [],
                employee_leave_approved_details_list: [],
                emp_approval_details: [],
                aws_path: null,
                headers: [
                    { text: "Sr. No", value: "srno", sortable: false },
                    { text: "Employee", value: "emp_name", sortable: false },
                    { text: "Academic Year", value: "ay", sortable: false },
                    { text: "Leave Type", value: "leave_type", sortable: false },
                    { text: "From Date", value: "from_date", sortable: false },
                    { text: "To Date", value: "to_date", sortable: false },
                    { text: "Days", value: "days", sortable: false },
                    { text: "Hours", value: "hours", sortable: false },
                    { text: "Reason", value: "reason", sortable: false },
                    { text: "File / Certificate", value: "file", sortable: false },
                    { text: "Details", value: "details", sortable: false },
                    { text: "Remark", value: "remark", sortable: false, width: 500 },
                    { text: "Staus", value: "status", sortable: false, width: 200 },
                    { text: "Update", value: "update", sortable: false },
                ],
                headers1: [
                    { text: "Sr. No", value: "srno", sortable: false },
                    { text: "Authority", value: "authority", sortable: false },
                    { text: "Authority Name", value: "authority_name", sortable: false },
                    {
                        text: "Date Of Application",
                        value: "application_push_date",
                        sortable: false,
                    },
                    {
                        text: "Date Of Approval",
                        value: "application_action_date",
                        sortable: false,
                    },
                    { text: "Status", value: "status", sortable: false },
                    { text: "Remark", value: "remark", sortable: false },
                ],
                headers2: [
                    { text: "Sr. No", value: "srno", sortable: false },
                    { text: "Employee", value: "appliedby", sortable: false },
                    { text: "Fromdate", value: "fromdate", sortable: false },
                    { text: "Todate", value: "todate", sortable: false },
                ],
                selected: [],
                total_selected: [],
                addRemark: "",
                update_loader: false,
            };
        },
        watch: {},
        methods: {
            clear() {
                this.org_data_list = [];
                this.show_tt = false;
            },
            getLeaveApprovalData() {
                const data = {
                    org: this.org.id,
                };
                axios
                    .post("/LeaveManagement/getLeaveApprovalData", data)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            (this.ay_list = res.data.ay_list),
                                (this.leave_type_list = res.data.leave_type_list),
                                (this.leave_approval_status_list = res.data.leave_approval_status_list),
                                (this.instructor_list = res.data.instructor_list);
                        } else {
                            this.showSnackbar("#b71c1c", "Wrong information");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        // 'use strict';
                    });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg_without_all")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
             approveBulkLeaves() {
                this.total_selected = [];
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_selected.push(this.selected[i].id);
                }
                if (this.total_selected.length <= 0) {
                    this.showSnackbar("#b71c1c", "Please select Teachers!"); // show snackbar
                }
                const formData = {
                    total_selected: this.total_selected,
                    status: "Approved",
                    remark: this.addRemark,
                    org: this.org.id,
                };
                this.update_loader = true;
                axios
                    .post("/LeaveManagement/bulkUpdateEmployeeLeaveApproval", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Leave updated successfully...");
                            this.update_loader = false;
                            this.fetch();
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.update_loader = false;
                    });
            },
            RejectBulkLeaves() {
                this.total_selected = [];
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_selected.push(this.selected[i].id);
                }
                if (this.total_selected.length <= 0) {
                    this.showSnackbar("#b71c1c", "Please select Teachers!"); // show snackbar
                }
                const formData = {
                    total_selected: this.total_selected,
                    status: "Rejected",
                    remark: this.addRemark,
                    org: this.org.id,
                };
                this.update_loader = true;
                axios
                    .post("/LeaveManagement/bulkUpdateEmployeeLeaveApproval", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Leave updated successfully...");
                            this.update_loader = false;
                            this.fetch();
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.update_loader = false;
                    });
            },
            cancelBulkLeaves() {
                this.total_selected = [];
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_selected.push(this.selected[i].id);
                }
                if (this.total_selected.length <= 0) {
                    this.showSnackbar("#b71c1c", "Please select Teachers!"); // show snackbar
                }
                const formData = {
                    total_selected: this.total_selected,
                    status: "Cancelled",
                    remark: this.addRemark,
                    org: this.org.id,
                };
                this.update_loader = true;
                axios
                    .post("/LeaveManagement/bulkUpdateEmployeeLeaveApproval", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Leave updated successfully...");
                            this.update_loader = false;
                            this.fetch();
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.update_loader = false;
                    });
            },

            showdetails(emp_leave_transaction_id) {
                this.dialog = true;
                const formData = {
                    emp_leave_transaction_id: emp_leave_transaction_id,
                };
                axios
                    .post("/LeaveManagement/getEmployeeLeaveDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.emp_approval_details = res.data.emp_transaction_list;
                            this.aws_path = res.data.aws_path;
                            this.month_transaction_count = res.data.employee_leave_approved_details_list.length;
                            this.employee_leave_approved_details_list = res.data.employee_leave_approved_details_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            update(item) {
                const formData = {
                    emp_data: item,
                    org: this.org.id,
                };
                this.update_loader = true;
                axios
                    .post("/LeaveManagement/updateEmployeeLeaveApproval", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Leave updated successfully...");
                            this.update_loader = false;
                            this.fetch();
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.update_loader = false;
                    });
            },
            fetch() {
                this.loader = true;
                const formData = {
                    ay: this.ay.id,
                    leave_type: this.leave_type,
                    leave_approval_status: this.leave_approval_status,
                    instructor: this.instructor,
                    fromdate: this.date_1,
                    todate: this.date_2,
                    org: this.org.id,
                };
                axios
                    .post("/LeaveManagement/fetchLeaveData", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.emp_leave_approval_transaction_list = res.data.emp_leave_approval_transaction_list;
                            this.leave_approval_status_details_list = res.data.leave_approval_status_details_list;
                            this.aws_path = res.data.aws_path;
                            this.loader = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped></style>
